import Wysimark from '@wysimark/vue'
export default Wysimark
export { Wysimark }